export default __webpack_public_path__ + "static/media/photo--sm--huda-2.e8ced10e.jpg";